export const heightConfig = {
  homeHeaderHeight: 80, // 系统标题高度
  navHeaderHeight: 31, // 路由标题栏高度（暂时不用）
  mainButtonHeight: 35, // 主表按钮高度（暂时不用）
  mainSearchFormHeight: 40, //主表查询高度（暂时不用）
  searchFormHeight: 100,
  mainMargin: 15, // 最常用边距（如查找面板）
  toolBarHeight: 60, // 工具栏按钮高度 + 工具栏margin-top + 工具栏margin-bottom = 40 + 10 + 10
}
// VXETable配置
export const tableConfig = {
  // table header高度
  headerHeight: 25,
  // table row高度
  rowHeight: 27,
  // 每页条数
  pageSizes: [50, 100, 200, 1000, 2000, 50000],
  // 默认每页条数
  defaultPageSize: 50,
  // 斑马纹颜色
  stripeColor: 'lightgray',
}

export const placeholderConfig = {
  relation: '关联获取',
  select: '选择获取',
  input: '输入',
  autoCode: '自动编码',
}

// 数值验证
export const validNumerical = {
  // 不限制
  none: 0,
  // 非负数
  nonNegative: 1,
  // 大于0
  greaterThanZero: 2,
  // 不能为0(仅整数有效)
  noZero: 3,
  // 为负数
  isNegative: 4,
}

// 公用字符串
export const messageConfig = {
  // 修改保存
  modifyClose: '存在修改，是否停留在该页面?',
  autoCode: '自动编码',
  inputPlaceholder: '输入',
  relationPlaceholder: '关联获取',
  defaultPlaceholder: '默认值',
  selectPlaceholder: '选择获取',
  calculatePlaceholder: '自动计算',
  emptyCurrent: '请选择要操作的数据!',
  emptyDataForSave: '不存在可保存数据!',
  blankDetail: '明细不能为空',
  save: {
    success: '保存成功',
  },
  del: {
    success: '删除成功',
    confirmTableRow: '确定删除本行数据？',
    confirm: '确定删除本单据？',
  },
  lock: {
    success: '锁定成功',
  },
  unlock: {
    success: '解锁成功',
  },
  push: {
    success: '下推成功',
  },
}

export const TEXT_COLOR_MAP = {
  RED: '#FA575D',
  GREY: '#aaaaaa',
  YELLOW: '#e8af17',
  GREEN: '#61BFAD',
}
